import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import HoverActionButtonsCell from '@/components/table/HoverActionButtonsCell';
import { updateLookupProperties } from '../../dictionaries/actions';
import { canEditDataset } from '../../helper';

const LookupValue = ({
  value,
  canEdit,
  canRead,
  showEdit,
  className,
  category,
  code,
  showUrlLinks,
}) => (
  <HoverActionButtonsCell
    canEdit={canEdit}
    canRead={canRead}
    className={clsx('aridhia-lookup-value', className)}
    content={value}
    exists
    showEdit={() => showEdit(category, code)}
    showPopup
    showUrlLinks={showUrlLinks}
  />
);

const mapStateToProps = ({
  auth: { role },
  datasets: { lookups },
}) => (
  {
    canEdit: canEditDataset(lookups, role),
    canRead: role.permissions.datasets.read,
    category: lookups.category,
    code: lookups.code,
  }
);

const mapDispatchToProps = {
  showEdit: () => updateLookupProperties({ isEditing: true }),
};

export default connect(mapStateToProps, mapDispatchToProps)(LookupValue);
